"use client";

import { useRouter } from 'next/navigation';

interface ArticleText2Props {
  firstValue?: string;
  secondValue?: string;
  sectionSlug?: string;
  parentSectionName?: string;
  parentSectionSlug?: string;
}

// Helper function to extract path from URL (removes domain if present)
const getPathFromUrl = (urlOrSlug: string): string => {
  if (!urlOrSlug) return '';
  // Remove domain if present (handles both with and without trailing slash)
  const cleanPath = urlOrSlug
    .replace(/^https?:\/\/(www\.)?dinamani\.com\/?/, '')
    .replace(/^\/+/, ''); // Remove leading slashes
  return cleanPath;
};

export default function ArticleText2({
  firstValue = "முகப்பு",
  secondValue = "வணிக",
  sectionSlug,
  parentSectionName,
  parentSectionSlug
}: ArticleText2Props) {
  const router = useRouter();

  const handleFirstClick = () => {
    router.push('/');
  };

  const handleParentClick = () => {
    if (parentSectionSlug) {
      const path = getPathFromUrl(parentSectionSlug);
      router.push(`/${path}`);
    }
  };

  const handleSecondClick = () => {
    if (sectionSlug) {
      const path = getPathFromUrl(sectionSlug);
      router.push(`/${path}`);
    }
  };

  return (
    <div className="w-full px-4 py-2">
      <div className="w-full flex items-center gap-2 flex-wrap">
        {/* Home link */}
        <button
          onClick={handleFirstClick}
          className="text-909090 text-14-tamil-500 hover:underline leading-[1.5] line-clamp-1 cursor-pointer"
        >
          {firstValue}
        </button>

        {/* Parent section (if exists) */}
        {/* {parentSectionName && (
          <>
            <span className="text-909090 text-20-english-400 line-clamp-1">/</span>
            <button
              onClick={handleParentClick}
              className="text-909090 text-14-tamil-500 hover:underline leading-[1.5] line-clamp-1 cursor-pointer"
            >
              {parentSectionName}
            </button>
          </>
        )} */}

        {/* Slash */}
        <span className="text-909090 text-20-english-400 line-clamp-1">/</span>

        {/* Current section link */}
        <button
          onClick={handleSecondClick}
          className="text-215EF9 text-14-tamil-500 hover:underline leading-[1.5] line-clamp-1 cursor-pointer"
        >
          {secondValue?.trim() === 'விளம்பரதாரர் செய்திகள்' ? 'Sponsored Content' : secondValue}
        </button>
      </div>
    </div>
  );
}
